import { TextField } from "capitalroadkit";
import clone from "lodash/cloneDeep";
import { Field } from "formik";
import withNameSpace from "../../../../../functions/withNameSpace";
import React from "react";
import VolumeCalculatorForm from "./index";
import RoundingMode from "../../../../../types/corporateActions/Activities/RoundingMode";
import { MenuItem } from "@material-ui/core";
import { parseEnum } from "../../../../../resources/formatters/Formatter";

const fields = {
  MULTIPLIER: "multiplier",
  ROUNDING_MODE: "roundingMode",
  SCALE: "scale",
};

const initialValues = (volumeCalculator) => ({
  [fields.MULTIPLIER]: volumeCalculator?.multiplier || "",
  [fields.ROUNDING_MODE]: volumeCalculator?.roundingMode || RoundingMode.HALF_UP,
  [fields.SCALE]: volumeCalculator?.scale || volumeCalculator?.scale === 0 ? volumeCalculator?.scale : 2,
});

const clean = (values, calculatorField) => {
  let cleanValues = clone(values);

  const volumeCalculator = {
    type: cleanValues[calculatorField][VolumeCalculatorForm.fields.TYPE],
    multiplier: cleanValues[calculatorField][fields.MULTIPLIER],
    roundingMode: cleanValues[calculatorField][fields.ROUNDING_MODE],
    scale: cleanValues[calculatorField][fields.SCALE],
  };

  for (const propName in volumeCalculator) {
    if (volumeCalculator[propName] === "") {
      delete volumeCalculator[propName];
    }
  }

  return volumeCalculator;
};

const MultiplierForm = ({ nameSpace }) => {
  return (
    <>
      <Field component={TextField} label="Multiplier" name={withNameSpace(nameSpace, fields.MULTIPLIER)} required />
      <Field
        component={TextField}
        label="Rounding mode"
        name={withNameSpace(nameSpace, fields.ROUNDING_MODE)}
        required
        select
      >
        {Object.values(RoundingMode).map((mode) => (
          <MenuItem key={mode} value={mode}>
            {parseEnum(mode)}
          </MenuItem>
        ))}
      </Field>
      <Field component={TextField} label="Scale" name={withNameSpace(nameSpace, fields.SCALE)} required />
    </>
  );
};

MultiplierForm.fields = fields;
MultiplierForm.initialValues = initialValues;
MultiplierForm.clean = clean;

export default MultiplierForm;
